export default "__VITE_ASSET__7b9ba128__"